// extracted by mini-css-extract-plugin
export default {"apply_short_note":"apply_apply_short_note__wpWX2","disclaimer":"apply_disclaimer__Y3VaT","disclaimer_check":"apply_disclaimer_check__8QLOP"};